/*
* 模型日志管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    DatePicker,
    theme,
    Tag,
    Statistic,
} from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth
} from '../../incs/FunHelper.js';

const { RangePicker } = DatePicker;

const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            colorSuccess,
            colorSuccessBg,
            colorError,
            colorErrorBg,

        },
    } = theme.useToken();

    const columns = [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        { title: '操作者', dataIndex: 'operation', key: 'operation', fixed: 'left', },
        {
            title: '请求Id', key: 'chat_completion_id',
            render: (record) => record.chat_completion_id || '-',
        },
        { title: '模型', dataIndex: 'model', key: 'model', },
        {
            title: '输入Tokens', key: 'prompt_tokens',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '50%' : '60%' }} color={colorSuccessBg}><Statistic valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess, }} value={record.prompt_tokens} /></Tag>,
        },
        {
            title: '输出Tokens', key: 'completion_tokens',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '50%' : '60%' }} color={colorErrorBg}><Statistic valueStyle={{ fontSize: CNF.fontSize - 2, color: colorError }} value={record.completion_tokens} /></Tag>,
        },
        {
            title: '总计Tokens', key: 'total_tokens',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '50%' : '60%' }} color={colorPrimaryBg}><Statistic valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.total_tokens} /></Tag>,
        },
        { title: '时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth + 60, },
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                // scroll={{ x: this.props.x }}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            operation: '',
            apiKey: '',
            model: '',
            startDate: '',
            endDate: '',
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeOperation = (e) => { this.setState({ operation: e.target.value }); }
    changeApiKey = (e) => { this.setState({ apiKey: e.target.value }); }
    changModel = (value) => { this.setState({ model: value }); this.search(); }
    changeTime = (_, dateString) => { this.setState({ startDate: dateString[0], endDate: dateString[1] }); this.search(); };
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /**
     * 获取操作日志列表
     */
    getLists() {
        const _this = this;
        const params = {
            'operation': this.state.operation,
            'api_key': this.state.apiKey,
            'model': this.state.model,
            'start_date': this.state.startDate,
            'end_date': this.state.endDate,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}log/models${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Input
                            onChange={this.changeOperation}
                            onPressEnter={this.search}
                            placeholder='操作者'
                            value={this.state.operation}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 3 : 4} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeApiKey}
                            onPressEnter={this.search}
                            placeholder='api-key'
                            value={this.state.apiKey}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <RangePicker
                            format='YYYY-MM-DD'
                            placeholder={['开始日期', '结束日期']}
                            onChange={this.changeTime}
                            style={{ width: '100%' }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT